import { apiConstructor } from '../api/ConstructorApi';


//Sinks JSON
//import sinks from './../json/sinks/sink.json';

//Tabletops JSON
//import tabletops from './../json/countertops/countertops.json';

//Mirrors JSON


import {defaultConfig} from './img';

//?stand=BRN.B1.119.54.4.XX-XX.,barno,glossy_enamel,CG-08&sink=NRB.NR2.12.54,C&tabletop=false&mirror=BL.60.140.XX-XX,bell,matte_enamel,CH-01

let sinks = []

let defaultConfiguration = [
    // {
    //     img: defaultConfig.barnoPlus,
    //     stand: {
    //         article: 'BRN.B1.119.54.4.XX-XX.',
    //         id: 'Barno',
    //         material: 'matte_enamel',
    //         color: 'CH-02',
    //     },
    //     sink: false,
    //     tabletop: false,
    //     mirror: {
    //         article: "BL.60.140.XX-XX",
    //         id: 'bell',
    //         material: 'matte_enamel',
    //         color: 'CH-01'
    //     },
    //     cabinet: {
    //         article: 'BRN.3.2.17.XX-XX.L/R',
    //         id: 'Barno',
    //         material: 'stained_oak_veneer',
    //         color: 'CM-03',
    //         position: 'L'
    //     }
    // },
    // {
    //     img: defaultConfig.barnoPlus,
    //     stand: {
    //         article: 'BRN.B1.80.52.3.XX-XX.',
    //         id: 'Barno',
    //         material: 'matte_enamel',
    //         color: 'СG-08',
    //     },
    //     sink: false,
    //     tabletop: {
    //         article: "KMB.KM6.8.54.2.XX-XX.L/R/C/D",
    //         color: "KM-03",
    //         position: "C",
    //     },
    //     mirror: {
    //         article: "LIN.120.90",
    //         id: 'line',
    //         material: false,
    //         color: false,
    //     },
    //     cabinet: false,
    // },
    // {
    //     img: defaultConfig.barnoPlus,
    //     stand: {
    //         article: 'BRN.B1.80.52.4.XX-XX.',
    //         id: 'barno',
    //         material: 'matte_enamel',
    //         color: 'СG-02',
    //     },
    //     sink: false,
    //     tabletop: {
    //         article: "SSB2.8.54",
    //         color: false,
    //     },
    //     mirror: {
    //         article: "BOX.110.700.XX-XX",
    //         id: 'box',
    //         material: 'stained_oak_veneer',
    //         color: 'CM-02',
    //         position: 'L'
    //     },
    //     cabinet: false,
    // },
    // {
    //     img: defaultConfig.barnoPlus,
    //     stand: {
    //         article: 'BRN.B1.80.52.3.XX-XX.',
    //         id: 'Barno',
    //         material: 'matte_enamel',
    //         color: 'СG-08',
    //     },
    //     sink: {
    //         article: "SLB.SL6.8.54.2.",
    //         position: "C",
    //         flap: "SS001"
    //     },
    //     tabletop: false,
    //     mirror: {
    //         article: "BOX.100.700.XX-XX",
    //         id: 'box',
    //         material: 'oak_veneer',
    //         color: 'CM-90'
    //     },
    //     cabinet: {
    //         article: 'BRN.4.3.15.XX-XX.L/R',
    //         id: 'barno',
    //         material: 'stained_oak_veneer',
    //         color: 'CM-03',
    //         position: 'L'
    //     }
    // },
    
]

// ?stand=barno,BRN.B1.80.52.4.XX-XX,glossy_enamel,СG-02&sink=false

let sinksJson = [];

let tabletopsJson = [];


function initTabletops() {
    return new Promise((resolve, reject) => {
        apiConstructor.getTabletops()
        .then(res => {
            tabletopsJson = res.data 
            resolve(true)
        })
        .catch(res=> {
            reject(false)
        })
    })
}



function initSinks() {
    return new Promise((resolve, reject) => {
        apiConstructor.getSinks()
        .then(res => {
            sinksJson = res.data 
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
    })
}

function initDefaultConfig() {
    return new Promise((resolve, reject) => {
        apiConstructor.getDefaultConfig()
        .then(res => {
            defaultConfiguration = res.data 
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
    })
}


export {defaultConfiguration, sinksJson, tabletopsJson, initSinks, initTabletops, initDefaultConfig}